<template>
  <div style="height: 100%">
    <v-slide-x-transition leave-absolute hide-on-leave>
      <div :key="view" class="transition Kanit">
        <component v-if="!loading" :is="view">
          <template v-slot:header>
            <div
              style="
                height: 90px;
                position: relative;
                overflow: hidden;
                background-color: #002969;
              "
            >
              <img style="height: 140px" src="@/assets/head.png" />
              <div class="Kanit headtext">
                {{ $store.state.headertext }}
              </div>
            </div>
          </template>
        </component>
        <div v-else class="text-center">
          <div class="text-center mt-2">
            <img width="62px" src="@/assets/logo.png" />
          </div>
          <v-progress-circular
            indeterminate
            class="mt-6"
            color="primary"
            size="65"
          ></v-progress-circular>
        </div>
      </div>
    </v-slide-x-transition>
  </div>
</template>

<script>
import queryString from "query-string";
import Login from "./Login.vue";
import ScanIMEI from "./ScanIMEI.vue";
import Profile from "./Profile.vue";

import AddPointSuccess from "./AddPointSuccess.vue";
import PointHistory from "./PointHistory";
import Register from "./Register/main.vue";
import ForgetPassword from "./ForgetPassword/main.vue";
import ForgetPassword2 from "./ForgetPassword2/main.vue";
import axios from "axios";
export default {
  components: {},
  data() {
    return {
      loading: true,
    };
  },
  components: {
    Login,
    Register,
    ScanIMEI,
    ForgetPassword,
    ForgetPassword2,
    AddPointSuccess,
    Profile,
    PointHistory,
  },
  async mounted() {
    var vm = this;
    vm.queryinit();
    await vm.init();
    if (!["Login", "Register", "ForgetPassword2"].includes(this.query.view)) {
      await vm.checkLogin();
    }
    vm.loading = false;
  },
  methods: {
    async checkLogin() {
      return new Promise((resolve) => {
        var data = {
          userid: this.userid,
          pageid: this.query.pageid,
        };

        axios
          .get(this.serverUrl + "yasale/check-login", {
            headers: { AUTHORIZATION: "Bearer xxx xxx" },
            params: data,
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              // await this.getMember();
              this.$store.state.member = response.data.data[0];
              if (["Login", "Register"].includes(this.query.view)) {
                this.query.view = "Profile";
              } else if (["ForgetPassword2"].includes(this.query.view)) {
                // this.query.view = "Profile";
              }
            } else if (response.data.responsecode == 204) {
              await this.$swal.fire({ text: response.data.reason });
              this.$store.state.redirectview = this.query.view;
              this.query.view = "Login";
            } else {
              await this.$swal.fire({ text: response.data.reason });
              this.$liff.closeWindow();
            }
            resolve();
          });
      });
    },
    init() {
      var vm = this;
      return new Promise(async (resolve) => {
        // var liffid = vm.$store.state.config[process.env.NODE_ENV].liffid
        var liffid = vm.$store.state.config[vm.$store.state.env].liffid

        // Production
        // 1656136806-YwgE9RjR

        // Test
        // var liffid = "1656136806-drBy0Y7Y";
        // var liffid = this.$liffid.home;

        if (this.query.apptype == "line") {
          await this.initializeLiff(liffid);
          // this.$store.state.userid =
          //   this.$store.state.profile.userId + "__" + this.query.pageid;
          this.$store.state.userid = this.query.userid;
          resolve();
        } else {
          this.$store.state.userid = this.query.userid;
          window.extAsyncInit = function () {
            // the Messenger Extensions JS SDK is done loading
          };
          resolve();
        }
      });
    },
    async initializeLiff(myLiffId) {
      var vm = this;
      var redirectUri = window.location.href;
      try {
        await this.$liff.init({
          liffId: myLiffId,
        });
        if (await this.$liff.isLoggedIn()) {
          this.$store.state.profile = await this.$liff.getProfile();
        } else {
          await this.$liff.login({ redirectUri });
        }
      } catch (error) {
        // alert(error.message);
      }
    },
    queryinit() {
      var vm = this;
      vm.$store.state.query = vm.$route.query["liff.state"]
        ? queryString.parse(vm.$route.query["liff.state"])
        : vm.$route.query;
    },
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    view() {
      return this.$store.state.query.view;
    },
  },
};
</script>

<style>
.myshadow {
  -webkit-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.65);
  box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.95);
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
.headtext {
  color: white;
  position: absolute;
  left: 50%;
  top: 50%;
  font-weight: 300;
  transform: translate(-50%, -50%);
  font-size: 25px;
}
</style>
